const Backbone = require('backbone');
const window = require('window');
const EstimatedDeliveryInformationModel = require('models/store/client/product/estimated_delivery');
const { ZipChangerView } = require('app/views/store/common/zip_changer');
const enums = require('lib/enums');
const productTrackingHelper = require('../../../../../lib/helpers/product_tracking_helper');
const FreeShippingMessageView = require('app/views/store/pages/products/freeshipping_message');
const gtmHelper = require('lib/helpers/gtm_helper');

module.exports = Backbone.View.extend({
	el: '.js-estimated-delivery',

	events: {
		'click .js-zip-change-button': 'handleFormToggleClick'
	},

	initialize: function() {
		const initialPostalCode = this.$el.data('postalCode') ? this.$el.data('postalCode').toString() : '';
		this.currentUniqueId = null;
		this.isFormShown = !this.$el.find('.js-zip-code-form').hasClass('hide');
		this.$displayBox = this.$el.find('.js-display-box');
		this.$messageText = this.$el.find('.js-message-text');
		this.$spinner = this.$el.find('.js-spinner');
		this.customerLocation = window.dataLayer.customerLocation || { highCost: false, zipCode: '' };
		this.$changeButton = this.$el.find('.js-change-button');
		this.$zipChangeButton = this.$el.find('.js-zip-change-button');
		this.zipChangerView = new ZipChangerView({
			zip: initialPostalCode
		});

		this.estimatedDeliveryModel = new EstimatedDeliveryInformationModel({
			postalCode: initialPostalCode,
			productCompositeId: this.model.get('productCompositeId')
		});

		this.freeShippingMessageView = new FreeShippingMessageView({
			model: this.model
		});
		this.freeShippingMessageView._toggleShippingMessage(this.customerLocation, false);

		this.listenTo(Backbone, 'finish:clicked', this.updateUniqueId.bind(this, true));
		this.listenTo(Backbone, 'finish:hover', this.updateUniqueId.bind(this, false));
		this.listenTo(Backbone, 'zipCode:changed', this.handleZipChanged);
		this.listenTo(Backbone, 'zipCode:noChange', this.handleZipChanged);
		this.listenTo(Backbone, 'zipCode:successLocation', this._trackZipCodeChangeSuccessLocation.bind(this));

		if (initialPostalCode) {
			if (this.estimatedDeliveryModel.isValid()) {
				this.estimatedDeliveryModel.fetch({
					success: () => {
						if (this.currentUniqueId) {
							this.renderViewAndFinishes();
						}
					},
					error: () => this.handleFetchError()
				});
			} else {
				this.renderViewAndFinishes();
				this.$displayBox.show();
			}
		} else {
			this.$displayBox.show();
		}
	},

	updateUniqueId: function(isClickEvent, data) {
		if (!data.uniqueId) {
			return;
		}

		this.currentUniqueId = data.uniqueId;
		if (this.estimatedDeliveryModel.get('estimatedDeliveryInfo')) {
			this.renderViewAndFinishes();
		}
	},

	getFinishPrice(uniqueId) {
		const finishes = window.dataLayer.finishes;
		const currentFinish = finishes.find((f) => f.uniqueId === uniqueId);
		if (currentFinish) {
			return currentFinish.price;
		}
		return null;
	},

	renderFinishes() {
		if (window.BCOM.device.isMobile) {
			const estimatedDeliveryInfo = this.estimatedDeliveryModel.get('estimatedDeliveryInfo');
			estimatedDeliveryInfo.forEach((deliveryInfo) => {
				this.render(deliveryInfo);
			});
		}
	},

	render: function(currentFinish) {
		const estimatedDeliveryInfo = this.estimatedDeliveryModel.get('estimatedDeliveryInfo');
		let $messageText = this.$messageText;
		if (currentFinish) {
			$messageText = $(`.js-mobile-finishes-estimated-delivery-${currentFinish.productUniqueId}`);
		} else {
			currentFinish = estimatedDeliveryInfo && estimatedDeliveryInfo.find((info) => info.productUniqueId === this.currentUniqueId);
		}
		window.BCOM.estimatedDeliveryInfo = estimatedDeliveryInfo;
		if (!currentFinish) {
			return;
		}
		this.$spinner.hide();
		this.$displayBox.show();
		this.$changeButton.show();
		const currentFinishPrice = this.getFinishPrice(this.currentUniqueId);
		window.BCOM.data = window.BCOM.data || {};
		window.BCOM.data.isQuickShip =
			currentFinish.isQuickShip && (currentFinishPrice > enums.FREESHIPPING_THRESHOLDS.PARCEL || currentFinish.freeShipping);
		// deliveryEstimateMethod === 'UPS_API' means estimation for ferguson parcel products.
		// deliveryEstimateMethod === 'VENDOR_SERVICE' means estimation for ferguson parcel products via vendor service logic.
		if (
			currentFinish.deliveryEstimateMethod &&
			currentFinish.deliveryEstimateMethod !== 'UPS_API' &&
			currentFinish.deliveryEstimateMethod !== 'VENDOR_SERVICE'
		) {
			$messageText.html(`${currentFinish.text}`);
			return;
		}
		if (currentFinish.deliveryEstimate) {
			$messageText.html(`${currentFinish.deliveryEstimate}`);
		} else if (currentFinish.text) {
			$messageText.html(`${currentFinish.text}`);
		} else {
			$messageText.html(`Delivery date not available for ${this.estimatedDeliveryModel.get('postalCode')}`);
		}
	},

	_trackLink(trackingData) {
		Backbone.trigger('track:link', trackingData);
	},

	handleFormToggleClick(e) {
		e.preventDefault();
		this.toggleForm();

		const linkName = `Estimated Delivery zip change ${this.isFormShown ? 'show form' : 'cancel change'}`;

		gtmHelper.fireEvent({
			event: 'generic-click-tracking',
			linkName: linkName
		});

		Backbone.trigger('track:link', {
			linkName: linkName
		});
	},

	toggleForm: function() {
		if (!this.zipChangerView) {
			return;
		}
		this.isFormShown = !this.isFormShown;
		if (this.isFormShown) {
			this.zipChangerView.show();
		} else {
			this.zipChangerView.hide();
		}

		this.$zipChangeButton.html(this.isFormShown ? 'Cancel' : 'Change Zip');
	},
	_trackZipCodeChangeSuccessLocation() {
		// exclude firing event on initial page load
		if (!window.dataLayer.zipCodeChangeEvent) {
			return false;
		}
		const hasRestrictions = window.dataLayer.restrictions && window.dataLayer.restrictions.length > 0;
		const estimatedDeliveryInfo = this.estimatedDeliveryModel.get('estimatedDeliveryInfo');
		// make data avail for add to cart tracking
		window.BCOM.estimatedDeliveryInfo = estimatedDeliveryInfo;
		let trackingData;
		if (window.dataLayer.page === 'product:display' || window.dataLayer.page === 'product-pla:display') {
			trackingData = productTrackingHelper.setZipChangeTrackingData(
				{
					categoryName: window.dataLayer.rootCategory && window.dataLayer.rootCategory.categoryName,
					freight: window.dataLayer.freight,
					manufacturer: window.dataLayer.manufacturer,
					sale: window.dataLayer.sale || (window.dataLayer.selectedFinish && window.dataLayer.selectedFinish.sale)
				},
				window.dataLayer.selectedFinish,
				window.dataLayer.finishes,
				this.currentUniqueId,
				'zip-change-success',
				estimatedDeliveryInfo
			);
			if (hasRestrictions) {
				trackingData.props.prop47 = '';
			}
		} else {
			trackingData = {
				linkName: 'zip-change-success'
			};
		}
		this._trackLink(trackingData);
	},
	handleZipChanged: function(postalCode) {
		if (postalCode && postalCode !== this.estimatedDeliveryModel.get('postalCode')) {
			this.toggleForm();
			this.$spinner.show();
			this.$displayBox.hide();
			this.estimatedDeliveryModel.set('postalCode', postalCode).fetch({
				success: () => {
					window.dataLayer.isEstimatedDeliveryUpdateComplete = true;
					if (window.dataLayer.isRestrictionsUpdateComplete) {
						this._trackZipCodeChangeSuccessLocation();
					}
					this.renderViewAndFinishes();
				},
				error: () => this.handleFetchError()
			});
		} else {
			Backbone.trigger('track:link', {
				linkName: `Estimated Delivery zip change same zip or fail`
			});
			this.toggleForm();
		}
	},
	handleFetchError: function() {
		this.estimatedDeliveryModel.unset('estimatedDeliveryInfo');
		this.renderViewAndFinishes();
	},
	renderViewAndFinishes: function() {
		this.render();
		this.renderFinishes();
	}
});
